module.exports = __webpack_public_path__ + "img/07.c346e2fc.jpg";